import React from "react";
import { UseFormRegister, FieldErrors, UseFormWatch } from "react-hook-form";
import InputField from "../../../components/form/InputField";
import { useTranslation } from "react-i18next";
import PasswordInput from "../../form/PasswordInput";

export interface PasswordFormData {
  oldPassword: string;
  newPassword: string;
  confirmPassword: string;
}

interface Props {
  register: UseFormRegister<PasswordFormData>;
  errors: FieldErrors<PasswordFormData>;
  watch: UseFormWatch<PasswordFormData>;
  onSubmit: () => void;
  isSubmitting?: boolean;
}

const PasswordFormStore: React.FC<Props> = ({ register, errors, watch, onSubmit, isSubmitting }) => {
  const { t } = useTranslation();
  const newPasswordValue = watch("newPassword");

  return (
    <div  className="">
      {/* Old Password */}
      <PasswordInput
        label={t("old_password")}
        placeholder={t("enter_old_password")}
        register={register("oldPassword", { required: `${t("required_field")}` })}
        error={errors.oldPassword}
      />

      {/* New Password */}
      <PasswordInput
        label={t("new_password")}
        placeholder={t("enter_new_password")}
        register={register("newPassword", { required: `${t("required_field")}` })}
        error={errors.newPassword}
      />

      {/* Confirm Password */}
      <PasswordInput
        label={t("confirm_password")}
        placeholder={t("confirm_new_password")}
        register={register("confirmPassword", {
          required: `${t("required_field")}`,
          validate: (value) =>
            value === newPasswordValue || t("passwords_do_not_match"),
        })}
        error={errors.confirmPassword}
      />
    </div>
  );
};

export default PasswordFormStore;
